import { CloseOutlined } from "@mui/icons-material";
import { Box, Stack, SwipeableDrawer } from "@mui/material";
import { BetaInfoContent } from "Components/Beta/BetaInfoContent";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { UnstyledButton } from "Components/Shared/Buttons/UnstyledButton";
import { Resources, useResource } from "Translations/Resources";
import { getIsBetaVisible } from "Utils/betaUtils";
import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "Utils/Storage/LocalStorage/SecureLocalStorage";
import { useState } from "react";

const RESOURCES = Resources.Beta.Drawer;

export const BetaInfoDrawer = () => {
  const [isOpen, setIsOpen] = useState(
    () => getLocalStorageItem(LocalStorageKeys.BetaDrawerSeen) !== "true",
  );
  const { t } = useResource();

  const close = () => {
    setLocalStorageItem(LocalStorageKeys.BetaDrawerSeen, "true");
    setIsOpen(false);
  };

  if (!getIsBetaVisible()) {
    return null;
  }

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={isOpen}
      onClose={close}
      onOpen={() => {}}
      slotProps={{
        paper: {
          sx: {
            p: 3,
            pb: { xs: 3, sm: 5 },
            maxHeight: "85vh",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          },
        },
      }}
      disableDiscovery
      // Opened from state only (onOpen is a no-op). Without this MUI keeps an invisible 20px swipe
      // strip along the bottom edge of every page, swallowing clicks on anything pinned there.
      disableSwipeToOpen
    >
      <Box display="flex" justifyContent="center" mb={4}>
        <Box
          aria-hidden
          width={80}
          height={6}
          bgcolor="grey.300"
          borderRadius={2}
        />
        <UnstyledButton
          aria-label={t(RESOURCES.Close)}
          onClick={close}
          sx={{
            position: "absolute",
            color: "grey.600",
            right: 12,
            top: 12,
          }}
        >
          <CloseOutlined />
        </UnstyledButton>
      </Box>
      <Stack gap={4} width="100%" maxWidth={600} mx="auto">
        <BetaInfoContent />
        <PrimaryButton color="primary" onClick={close} fullWidth>
          {t(RESOURCES.Continue)}
        </PrimaryButton>
      </Stack>
    </SwipeableDrawer>
  );
};
